import React, {useEffect, useState} from "react";
import {observer} from "mobx-react";
import {AgGridReact} from "ag-grid-react";
import {taxAuthApi} from "../../../api/taxAuth.js";
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import {Badge, Button, Card, Container} from "react-bootstrap";
import {useNavigate} from "react-router-dom";
import HeroSection from "../../../components/HeroSection.jsx";

const ActionCellRenderer = (props) => {
    const navigate = useNavigate();
    const { data } = props;

    const handleDetailsClick = () => {
        navigate(`/admin/taxAuth/${data.id}`);
    };

    return (
        <Button variant="primary" size="sm" onClick={handleDetailsClick}>
            Details
        </Button>
    );
};

function TaxAuthAdminPage() {
    const [rowData, setRowData] = useState();
    const navigate = useNavigate();
    const [columnDefs] = useState([
        {field: 'name', headerName: 'Tax Authority', filter: true},
        {field: 'online', headerName: 'Online?', filter: true},
        {headerName: 'Actions', cellRenderer: ActionCellRenderer}
    ]);

    useEffect(() => {
        const loadTaxAuths = async () => {
            const taxAuthorities = await taxAuthApi.getTaxAuthorities();
            setRowData(taxAuthorities);
        }
        loadTaxAuths();
    }, []);

    return (
        <Container className="dashboard-shell">
            <HeroSection
                accent="admin"
                eyebrow="Admin"
                title="Tax Authority Administration"
                subtitle="Manage municipalities and their online status."
                actions={<Button variant="primary" onClick={() => navigate(`/admin/inviteTaxAuth`)}>Invite Tax Authority</Button>}
            />
            <Card className="dashboard-panel mt-4">
                <Card.Header className="bg-white d-flex justify-content-between align-items-center">
                    <strong>Tax Authorities</strong>
                    <Badge bg="light" text="dark">{rowData?.length || 0}</Badge>
                </Card.Header>
                <Card.Body>
                    <div className="ag-theme-alpine dashboard-grid" style={{height: 600, width: '100%'}}>
                        <AgGridReact
                            rowData={rowData}
                            columnDefs={columnDefs}
                            domLayout='autoHeight'
                        />
                    </div>
                </Card.Body>
            </Card>
        </Container>
    );
}

export default observer(TaxAuthAdminPage);
